<template>
  <div id="app">
    <CalculadoraForm />
  </div>
</template>

<script>
import CalculadoraForm from './components/CalculadoraForm.vue'

export default {
  name: 'app',
  components: {
    CalculadoraForm
  }
}
</script>

<style>
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*!*color: #2c3e50;*!*/
  /*margin-top: 60px;*/
}
  #app.a{
    color: white;
  }
</style>
